<template>
  <!--Always show newsletter in homeview desktop-->
  <div class="monster-newsletter-widget gtm-onElementVisiblity"
       :class="`theme-${newsletterType.color}`"
       gtm-on="elementVisibility"
       :gtm-visibility-category="gtmNewsletterCategory"
       gtm-visibility-action="Newsletter widget impression"
       :gtm-visibility-label="newsletterType.name"
       v-if="inHomeView ? true : showNewsletter"
       >
    <div class="content-row">
      <div class="envelopes-wrapper left">
        <!--Left envelope panel-->
        <div class="envelope-row animated" v-for="x in 5" :key="x" :class="{odd: x%2 === 1, even: x%2 === 0}">
          <svg-email-eight-bit-icon class="email-icon" v-for="y in 7" fill="#F8008E" width="30" height="21" :key="y" :class="{ first:y === 1, last:y === 7 }"></svg-email-eight-bit-icon>
        </div>
      </div>
      <div class="rect-wrappers-container animated" ref="rectWrappersContainer">
        <div class="monster-wrappers">
          <div class="monster-content">
            <div class="monster-icon">
              <svg-email-monster-icon width="394" height="138"></svg-email-monster-icon>
            </div>
            <div class="monster-email-row">
              <svg-email-eight-bit-icon v-for="n in 3" :class="{ first:n === 1, last:n === 3 }" width="39" height="28" :key="n"></svg-email-eight-bit-icon>
            </div>
          </div>
          <div class="message-headline" :class="newsletterType.color">thank you</div>
          <div class="message-content" :class="newsletterType.color">you are now on the email list</div>
        </div>
        <div class="rect-wrapper-parent">
          <div class="rect-wrapper-content">
            <div class="brand-title">GET OUR</div>
            <div class="newsletter-type" :class="newsletterType.color">{{newsletterType.name}}</div>
            <div class="newsletter-title" :class="newsletterType.color">NEWSLETTER</div>
          </div>

          <div class="rect-wrapper first" :class="[newsletterType.color, 'rect-wrapper-frame-' + n]" v-for="n in 5">
            <div class="rect-wrapper second" :class="newsletterType.color">
              <div class="rect-wrapper third" :class="newsletterType.color">
                <div class="rect-wrapper forth" :class="newsletterType.color">
                  <div class="rect-wrapper fifth" :class="newsletterType.color">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Newsletter Input Form-->
        <div class="newsletter-form" v-if="!submit">
          <form @submit.prevent="onSubmit" class="mx-auto disable-translate3d" novalidate>
            <div class="row justify-content-center disable-translate3d">
              <div class="form-input">
                <input type="email" class="w-100 form-control border-0 pl-2 pr-2 input-email" :class="{'warning-color': warning }" v-model.trim="monsterEmail" placeholder="your email">
              </div>
              <button class="form-btn btn submit-newsletter" type="submit">SIGN UP</button>
            </div>
            <div class="warning notification" :class="{'warning-color': warning }">
              <div class="d-flex align-items-center pr-3 pl-3 h-100" v-if="warning">Email Address is not valid.</div>
            </div>
          </form>
        </div>
      </div>
      <div class="envelopes-wrapper right">
        <!--Right envelope panel-->
        <div class="envelope-row animated" v-for="x in 5" :key="x" :class="{odd: x%2 === 1, even: x%2 === 0}">
          <svg-email-eight-bit-icon class="email-icon" v-for="y in 7" fill="#F8008E" width="30" height="21" :key="y" :class="{ first:y === 1, last:y === 7 }"></svg-email-eight-bit-icon>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import get from 'lodash/get'

  import SvgEmailEightBitIcon from 'static/svg/icon_email_8bit.svg'
  import SvgEmailMonsterIcon from 'static/svg/raw/email_monster.svg'
  import NewsletterMixin from 'components/mixins/newsletter'
  import { getNewsLetterMapping } from 'mixins/utilities'
  import GTMManager from 'mixins/gtm-manager'

  export default {
    mixins: [NewsletterMixin],
    props: {
      sections: {
        type: Array,
        default: () => [],
      },
      gtmType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        submit: false,
        monsterEmail: '',
        warning: false,
        subscription: false,
        flag: false,
      }
    },
    components: {
      SvgEmailEightBitIcon,
      SvgEmailMonsterIcon,
    },
    computed: {
      ...mapState(['showNewsletter']),
      newsletterType() {
        return getNewsLetterMapping(this.sections) || {}
      },
      gtmNewsletterCategory() {
        return get(GTMManager.getDynamicGtmEventsByType(this.gtmType, {}), 'category', false)
      },
      inHomeView() {
        return this.$route.name === 'Home'
      },
    },
    methods: {
      onSubmit() {
        if (this.validateEmail(this.monsterEmail)) {
          this.warning = false
          this.submit = true
          this.play1()
          setTimeout(() => { this.play2() }, 2300)
          this.subscribeNewsletter(this.monsterEmail, this.newsletterType, this.gtmNewsletterCategory)
        } else {
          this.warning = true
          this.submit = false
        }
      },
    },
    watch: {
      submit(val) {
        if (val) {
          // Trigger the animation
          this.$refs.rectWrappersContainer.classList.remove('animated')
          this.$refs.rectWrappersContainer.classList.add('subscribe-animated')
        }
      },
    },
    mounted() {
      this.checkSubscribedToList(this.newsletterType)
    },
  }
</script>

<style lang="scss" scoped>
  .blue {
    color: $waterspout;
    border-color: $waterspout;
  }

  .green {
    color: $jade;
    border-color: $jade;
  }

  .yellow {
    color: $banana-yellow;
    border-color: $banana-yellow;
  }

  @keyframes toWhiteBorderOne {
      20%, 40%, 60%, 80%, 100% { transform: scale(0); }
      0% { transform: scale(1); }
  }
  @keyframes toWhiteBorderTwo {
      0%, 40%, 60%, 80%, 100% { transform: scale(0); }
      20% { transform: scale(1); }
  }
  @keyframes toWhiteBorderThree {
      0%, 20%, 60%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
  }

  @keyframes emailTranslateLeft {
      50% { transform: translateX(-25px); } 100% { transform: translateX(0); }
  }

  @keyframes emailTranslateLeftReverse {
      50% { transform: translateX(0); } 100% { transform: translateX(-25px); }
  }

  @keyframes emailTranslateRight {
      50% { transform: translateX(25px); } 100% { transform: translateX(0); }
  }

  @keyframes emailTranslateRightReverse {
      50% { transform: translateX(0); } 100% { transform: translateX(25px); }
  }

  @keyframes monsterEnvelopTranslate {
      0%, 50%, 100% { transform: translateX(0); }
      25% {transform: translateX(-5px);}
      75% {transform: translateX(5px);}
  }

  @keyframes frameEnlarge {
    to {
      transform: scale(1.3);
      opacity: 0;
    }
  }

  .monster-newsletter-widget {
    position: relative;
    background-color: $black;
    padding-top: rem-calc(24);
    padding-bottom: rem-calc(67);
    overflow: hidden;
  }

  .newsletter-form {
    position: absolute;
  }

  .envelopes-wrapper {
    margin-top: rem-calc(21);
    &.left {
      .envelope-row:nth-child(even) {
        transform: translateX(-25px);
      }
    }
    &.right {
      .envelope-row:nth-child(even) {
        transform: translateX(25px);
      }
    }
  }

  .content-row {
    text-align: center;
    width: rem-calc(1400);
    left: 50%;
    margin-left: rem-calc(-700);
    position: relative;

    & > div {
      vertical-align: top;
      display: inline-block;
    }
  }


  .envelope-row {
    margin-top: rem-calc(8);
    margin-bottom: rem-calc(8);
    .email-icon:not(.last) {
      margin-right: rem-calc(24);
    }
    &.animated {
      animation-iteration-count: infinite;
      animation-delay: 0;
      animation-duration: 6s;
      animation-timing-function: steps(5, end);
    }
  }

  .envelopes-wrapper.left .envelope-row.animated {
    &.odd {
      animation-name: emailTranslateLeft;
      #app[data-browser="safari"] & {
        animation-name: none;
      }
    }
    &.even {
      animation-name: emailTranslateLeftReverse;
      #app[data-browser="safari"] & {
        animation-name: none;
      }
    }
  }

  .envelopes-wrapper.right .envelope-row.animated{
    &.odd {
      animation-name: emailTranslateRight;
      #app[data-browser="safari"] & {
        animation-name: none;
      }
    }
    &.even {
      animation-name: emailTranslateRightReverse;
      #app[data-browser="safari"] & {
        animation-name: none;
      }
    }
  }

  .rect-wrappers-container {

    width: rem-calc(520);
    margin-left: rem-calc(30);
    margin-right: rem-calc(30);
    position: relative;

    &.animated {
      .rect-wrapper-parent {
        width: 100%;
        height: 100%;
      }
      .rect-wrapper {
        &.rect-wrapper-frame-1 {
          animation-name: toWhiteBorderOne;
          #app[data-browser="safari"] & {
            animation-name: none;
          }
          .fifth {
            border-color: $white;
          }
        }
        &.rect-wrapper-frame-2 {
          animation-name: toWhiteBorderTwo;
          #app[data-browser="safari"] & {
            animation-name: none;
          }
          .forth {
            border-color: $white;
          }
        }
        &.rect-wrapper-frame-3 {
          animation-name: toWhiteBorderThree;
          #app[data-browser="safari"] & {
            animation-name: none;
          }
          .third {
            border-color: $white;
          }
        }
        &.rect-wrapper-frame-4 {
          animation-name: toWhiteBorderTwo;
          animation-direction: reverse;
          #app[data-browser="safari"] & {
            animation-name: none;
          }
          .second {
            border-color: $white;
          }
        }
        &.rect-wrapper-frame-5 {
          animation-name: toWhiteBorderOne;
          animation-direction: reverse;
          #app[data-browser="safari"] & {
            animation-name: none;
          }
          &.first {
            border-color: $white;
          }
        }
        animation-duration: 1.6s;
        animation-timing-function: steps(1, end);
        animation-iteration-count: infinite;
        animation-delay: 0;
        &.first {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }
      }
    }

    &.subscribe-animated {

      .rect-wrapper-content {
        opacity: 0;
      }

      .monster-wrappers {
        transform: translateY(0);
      }

      .monster-icon,
      .monster-email-row {
        animation-name: monsterEnvelopTranslate;
        animation-duration: 2.4s;
        animation-iteration-count: infinite;
        animation-timing-function: steps(1, end);
        animation-delay: 1s;
      }
      .monster-email-row {
        animation-delay: 2.2s;
      }

      .message-headline,
      .message-content {
        transform: translate(0, 0);
      }
      .rect-wrapper-frame-1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
      .rect-wrapper-frame-2,
      .rect-wrapper-frame-3,
      .rect-wrapper-frame-4,
      .rect-wrapper-frame-5 {
        display: none;
      }

      .rect-wrapper {
        animation-duration: .2s;
        animation-timing-function: ease;
        animation-delay: 0;
        animation-fill-mode: forwards;
        animation-name: frameEnlarge;

        &.first {
          animation-delay: .4s;
        }
        &.second {
          animation-delay: .3s;
        }
        &.third {
          animation-delay: .2s;
        }
        &.forth {
          animation-delay: .1s;
        }
      }
    }
  }

  .rect-wrapper-content {
    overflow: hidden;
    font-family: $silkscreen;
    opacity: 1;
    transition: all .6s ease-in-out;
    padding: rem-calc(65) 0;
    .brand-title {
      font-family: $font-04b03;
      font-size: rem-calc(24);
      line-height: rem-calc(24);
      margin-bottom: rem-calc(4);
      color: $rose;
    }
    .newsletter-type {
      font-size: rem-calc(32);
      line-height: rem-calc(27);
      font-weight: bold;
      text-shadow: rem-calc(2) rem-calc(2) rem-calc(0) $rose;
      margin-bottom: rem-calc(7);
    }
    .newsletter-title {
      font-size: rem-calc(24);
      line-height: rem-calc(24);
    }
  }

  .rect-wrapper {
    border-style: solid;
    opacity: 1;

    &.first {
      border-width: rem-calc(6);
      padding: rem-calc(10 20 9);

    }
    &.second {
      border-width: rem-calc(4);
      padding: rem-calc(9 20);
    }
    &.third {
      border-width: rem-calc(3);
      padding: rem-calc(10 14);
    }
    &.forth {
      border-width: rem-calc(2);
      padding: rem-calc(10 14);
    }
    &.fifth {
      border-width: rem-calc(1);
      padding-top: rem-calc(11);
      padding-bottom: rem-calc(9);
      height: 108px;
    }
  }

  .monster-wrappers {
    position: absolute;
    width: 100%;
    text-align: center;
    transform: translateY(-140px);
    margin-top: rem-calc(-25);
    // Delay 1 s
    transition: transform 1s ease 1s;
    .monster-content {
      display: inline-block;
      position: relative;
      margin-bottom: rem-calc(10);
      z-index: 1;
      width: rem-calc(394);
      height: rem-calc(144);
    }
    .monster-icon {
      position: absolute;
    }
    .monster-email-row {
      position: absolute;
      bottom: 0;
      top: 35%;
      left: 0;
      width: 100%;
      svg {
        margin: rem-calc(0 31);
      }
    }
    .message-headline,
    .message-content {
      font-family: $silkscreen;
      text-transform: uppercase;
      max-width: rem-calc(237);
      margin: 0 auto;
    }
    .message-headline {
      font-size: rem-calc(32);
      line-height: rem-calc(27);
      font-weight: bold;
      text-shadow: rem-calc(2) rem-calc(2) rem-calc(0) $rose;
      transform: translate(-40px, -110px);
      transition: transform .5s ease-in-out 2.6s;
      margin-bottom: rem-calc(8);
    }
    .message-content {
      font-size: rem-calc(24);
      line-height: rem-calc(24);
      transform: translate(30px, -160px);
      transition: transform .5s ease-in-out 2.5s;
    }
  }

  .warning {
    div {
      font-family: $barlow;
      font-size: rem-calc(12);
      line-height: rem-calc(14);
    }
    height: rem-calc(35);
    margin-top: rem-calc(52);
  }


  .notification.warning-color {
    background: $neon-fuchsia;

    @include respond-to('desktop') {
      margin-left: -50vw;
      margin-right: -50vw;

      > div {
        justify-content: center;
        font-weight: bold;
        color: $white;
        font-size: rem-calc(14);
      }
    }
  }
  input.warning-color {
    color: $neon-fuchsia;
  }

  .newsletter-form {
    position: absolute;
    bottom: rem-calc(0);
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 2;
    top: rem-calc(190);
    max-width: rem-calc(347);

    .input-email {
      font-family: $barlow;
      font-size: rem-calc(24);
      border-radius: unset;
      border-bottom: 3px solid $manatee;
      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
      &::-moz-placeholder {
        /* Firefox 19+ */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
      &:-ms-input-placeholder {
        /* IE 10+ */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
      &:-moz-placeholder {
        /* Firefox 18- */
        color: $pastel-gray;
        padding-left: rem-calc(8);
      }
    }
    .form-input {
      margin: 4px;
      background: $white;
      padding: 0;
      transition: all 0.2s ease-in-out;
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 58.333333%;
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
      position: absolute;
      z-index: 3;
      left: 0;
      right: 0;
      top: 0;
    }
    .form-btn {
      width: rem-calc(115);
      border: 4px solid $rose;
      border-left: none;
      background: $rose;
      transition: all 0.2s ease-in-out;
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 33.333333%;
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
      box-sizing: content-box;
      padding-left: rem-calc(212);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: rem-calc(28);
      text-align: right;
      &:hover {
        border-color: $neon-fuchsia;
        background-color: $neon-fuchsia;

        @include respond-to('mobile') {
          background: $jazzberry-jam;
          border-color: $jazzberry-jam;
        }
      }
      &:focus {
        border-color: $jazzberry-jam;
        background-color: $jazzberry-jam;
      }
    }
    input {
      caret-color: $rose;
      outline-width: rem-calc(2);
      height: rem-calc(45);
    }
    .submit-newsletter {
      background: $rose;
      border-radius: unset;
      font-size: rem-calc(20);
      color: $white;
      font-family: $silkscreen;
      &:focus {
        box-shadow: none;
      }
      span {
        font-size: rem-calc(20);
        color: $white;
        font-family: $silkscreen;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// MonsterNewsletterFormDesktop.vue?58764808